import { combineReducers } from 'redux';

import assignmentPending from './assignment-pending-req';
import assignmentReviewed from './assignment-reviewed-req';
import assignmentUpdate from './assignment-update-req';

export default combineReducers({
  assignmentPending,
  assignmentReviewed,
  assignmentUpdate,
});



// WEBPACK FOOTER //
// ./src/redux/dependentManagement/index.js